import React from "react";
import { Box } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import StarBorderIcon from "@mui/icons-material/StarBorder";

interface StarRatingProps {
  /** Rating on a 0-5 scale. */
  value: number | null | undefined;
  max?: number;
  size?: "small" | "medium" | "large";
  color?: string;
}

const SIZE_PX: Record<NonNullable<StarRatingProps["size"]>, number> = {
  small: 16,
  medium: 20,
  large: 28,
};

/** Renders a 0-5 rating as full/half/empty stars (read-only). */
const StarRating: React.FC<StarRatingProps> = ({ value, max = 5, size = "medium", color = "#f5a623" }) => {
  const rating = value === null || value === undefined || Number.isNaN(value) ? 0 : Math.max(0, Math.min(max, value));
  const fontSize = SIZE_PX[size];

  const stars = Array.from({ length: max }, (_, idx) => {
    const starValue = idx + 1;
    if (rating >= starValue) {
      return <StarIcon key={idx} sx={{ fontSize, color }} />;
    }
    if (rating >= starValue - 0.5) {
      return <StarHalfIcon key={idx} sx={{ fontSize, color }} />;
    }
    return <StarBorderIcon key={idx} sx={{ fontSize, color }} />;
  });

  return (
    <Box sx={{ display: "inline-flex", alignItems: "center" }} aria-label={`Rating: ${rating} out of ${max}`}>
      {stars}
    </Box>
  );
};

export default StarRating;
